import { FieldInputType } from 'maestro-shared/schema/SpecificData/ProgrammingSubPlanFieldConfig';
import { UnknownValueLabel } from 'maestro-shared/schema/SpecificData/SpecificData';
import { selectOptionsFromList } from '../../../components/_app/AppSelect/AppSelectOption';

export const FieldInputTypeLabels: Record<FieldInputType, string> = {
  text: 'Texte court',
  number: 'Nombre',
  decimal: 'Nombre décimal',
  textarea: 'Texte long',
  date: 'Date',
  select: 'Liste',
  selectWithUnknown: `Liste avec "${UnknownValueLabel}"`,
  checkbox: 'Case à cocher',
  radio: 'Bouton radio',
  multiselect: 'Liste à choix multiple'
};

export const fieldInputTypeOptions = selectOptionsFromList(
  FieldInputType.options,
  { labels: FieldInputTypeLabels }
);

export const fieldInputTypeOptionsWithDefault = selectOptionsFromList(
  FieldInputType.options,
  {
    labels: FieldInputTypeLabels,
    withDefault: true,
    defaultLabel: 'Sélectionner un type'
  }
);
